var map = {
	"./arrow.svg": "3066",
	"./calc.svg": "584c",
	"./call.svg": "6004",
	"./gift+.svg": "0e88",
	"./gift.svg": "23c67",
	"./info.svg": "1cfe",
	"./price.svg": "0fc8",
	"./route.svg": "5f12",
	"./service.svg": "aab0",
	"./testdrive.svg": "44f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22ef";